/**
 * 현재 선택된 서버 환경에 따라 리소스 기본 URL을 반환합니다.
 * @returns {string} 리소스 기본 URL
 */
export const getResourceBaseUrl = () => {
	const server = localStorage.getItem("selectedServer");

	switch (server) {
		case "dev-api-backstage.sleepwave.ai":
			return "https://dev-resource.sleepwave.ai";
		case "stg-api-backstage.sleepwave.ai":
			return "https://stg-resource.sleepwave.ai";
		case "kr-api-backstage.sleepwave.ai":
		case "us-api-backstage.sleepwave.ai":
			return "https://resource.sleepwave.ai";
		default:
			return "https://dev-resource.sleepwave.ai"; // 기본값
	}
};

/**
 * 리소스 경로에 기본 URL을 추가하여 완전한 URL을 생성합니다.
 * @param {string} path - 리소스 경로
 * @returns {string} 완전한 리소스 URL
 */
export const getResourceUrl = (path) => {
	if (!path) return "";

	// 이미 http로 시작하는 경우 그대로 반환
	if (path.startsWith("http")) return path;

	// 경로가 /로 시작하지 않으면 추가
	const formattedPath = path.startsWith("/") ? path : `/${path}`;

	return `${getResourceBaseUrl()}${formattedPath}`;
};
